import React, {useEffect, useState} from "react";
import { useLocation, useParams } from "react-router-dom";
import parse from 'html-react-parser';
import { getSlumSoccerProjects } from "../graphql/queries";
import { generateClient } from "aws-amplify/api";
import { Loader2 } from "lucide-react"; 

const client = generateClient();

export function ProjectDetails(props) {
  const { id } = useParams(); // Get project ID from URL
  const [html,setHtml] = useState(null);
  const [project, setProject] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      let pendingData = await client.graphql({
        query: getSlumSoccerProjects,
        variables: { projectid: id },
      });

      const project = pendingData["data"]["getSlumSoccerProjects"];
      const content = JSON.parse(JSON.parse(project.mainContent));
      setProject(project);
      setHtml(content.html);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching project:", error);
      setIsLoading(false);
    }
  }

  console.log('project html', html);

  const LoadingIndicator = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <Loader2 
        className="animate-spin text-white" 
        size={64} 
      />
    </div>
  );

  // If loading, show the circular progress indicator
  if (isLoading) {
    return <LoadingIndicator />;
  }
  

  return (
    <>
      <section className="relative w-full h-screen flex items-center justify-center">
        {/*  Background Image*/}
        <div className="absolute inset-0">
          <img
            src={project.imgUrl}
            alt={project.title}
            className="w-full h-[650px] object-cover  animate__animated animate__fadeIn"
          />

          {/* <div className="absolute inset-0 bg-black/10"></div> */}
        </div>

        {/* <!-- Text Overlay --> */}
        <div className="relative z-10 text-center animate-fadeIn">
          <h1 className="text-5xl md:text-6xl font-bold text-white">
            {project.title}
          </h1>
        </div>
      </section>

      {/* Information Section */}
      <section className="bg-white text-gray-800 px-5 md:px-15 lg:px-23 py-11">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-4 text-orange-500 ">{project.title}</h2>
          {html && <div className="" dangerouslySetInnerHTML={{ __html: html }}></div>}
          {/* <div className="preflight-override">
            {html}
          </div> */}
        </div>
      </section>
    </>
  );
}
